import { useState } from "react";
import { MapContainer, TileLayer, Circle, CircleMarker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const HAVANA = [22.4069, -79.9649];

function Clicker({ onPick }) {
  useMapEvents({ click: (e) => onPick && onPick({ lat: +e.latlng.lat.toFixed(6), lng: +e.latlng.lng.toFixed(6) }) });
  return null;
}

export function MapPick({ value, onChange, circles = [], height = 220, testId = "map" }) {
  const [mapKey] = useState(() => `m${Math.random().toString(36).slice(2)}`);
  const center = value ? [value.lat, value.lng] : circles[0] ? [circles[0].lat, circles[0].lng] : HAVANA;
  return (
    <div className="rounded-xl overflow-hidden border border-border" style={{ height }} data-testid={testId}>
      <MapContainer key={mapKey} center={center} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Clicker onPick={onChange} />
        {circles.map((c, i) => <Circle key={c.id || `${c.lat}-${c.lng}-${i}`} center={[c.lat, c.lng]} radius={(c.r || 1) * 1000} pathOptions={{ color: c.color || "#06B6D4", fillOpacity: 0.08 }} />)}
        {value && <CircleMarker center={[value.lat, value.lng]} radius={9} pathOptions={{ color: "#10B981", fillColor: "#10B981", fillOpacity: 0.9 }} />}
      </MapContainer>
    </div>
  );
}
